import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';

class RedirectToLogin extends Component {
  static defaultProps = {
    loginPath: '/'
  }

  componentDidMount() {
    const { requestedPath, dispatch } = this.props;

    dispatch({ type: 'SAVE_REQUESTED_PATH', payLoad: requestedPath });
  }

  render() {
    const { loginPath } = this.props;
    return (
      <Redirect to={loginPath}/>
    );
  }
}

export default connect()(RedirectToLogin);



// WEBPACK FOOTER //
// ./src/components/common/redirect-to-login.jsx